var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.idx == null ? 'Add Refund Item' : 'Edit Refund Item',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1000px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Refund Order",
      "prop": "orderId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": "",
      "disabled": _vm.idx != null,
      "placeholder": "Select refund order"
    },
    on: {
      "change": _vm.orderIdChange
    },
    model: {
      value: _vm.dataForm.orderId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "orderId", $$v);
      },
      expression: "dataForm.orderId"
    }
  }, _vm._l(_vm.paidOrderInfoList, function (item) {
    return _c('el-option', {
      key: "orderId-".concat(item.id),
      attrs: {
        "label": item.description,
        "value": item.id,
        "disabled": _vm.usedOrderIdList.includes(item.id),
        "title": _vm.usedOrderIdList.includes(item.id) ? 'Already in use' : ''
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Invoice Template",
      "prop": "invoiceTemplateId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.invoiceTemplateChange
    },
    model: {
      value: _vm.dataForm.invoiceTemplateId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "invoiceTemplateId", $$v);
      },
      expression: "dataForm.invoiceTemplateId"
    }
  }, _vm._l(_vm.invoiceTemplateList, function (item) {
    return _c('el-option', {
      key: "invoiceTemplate-".concat(item.id),
      attrs: {
        "label": item.templateName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Gov Fee",
      "prop": "deductionAcraFee"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Gov Fee"
    },
    model: {
      value: _vm.dataForm.deductionAcraFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "deductionAcraFee", $$v);
      },
      expression: "dataForm.deductionAcraFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.billingCurrency)))])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Handling Fee",
      "prop": "deductionHandlingFee"
    }
  }, [_c('el-input', {
    directives: [{
      name: "positivePoint",
      rawName: "v-positivePoint"
    }],
    attrs: {
      "clearable": "",
      "placeholder": "Handling Fee"
    },
    model: {
      value: _vm.dataForm.deductionHandlingFee,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "deductionHandlingFee", $$v);
      },
      expression: "dataForm.deductionHandlingFee"
    }
  }, [_c('template', {
    slot: "prefix"
  }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.billingCurrency)))])], 2)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Accounts",
      "prop": "bankAccountIds"
    }
  }, [_vm.dataForm.invoiceTemplateId ? [_c('select-bank-account', {
    attrs: {
      "supplierBankAccountList": _vm.invoiceTemplateBankAccountList
    },
    model: {
      value: _vm.dataForm.bankAccountIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "bankAccountIds", $$v);
      },
      expression: "dataForm.bankAccountIds"
    }
  })] : _c('div', {
    staticClass: "notSelectTipBg"
  }, [_vm._v("Select invoice template first")])], 2)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Apply Reason",
      "prop": "applyReason"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Apply Reason"
    },
    model: {
      value: _vm.dataForm.applyReason,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "applyReason", $$v);
      },
      expression: "dataForm.applyReason"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }